const mixin = {
  data() {
    return {
      Model: {
        managersName: null,
        managersSex: null,
        managersAge: null,
        managersDocumentsType: null,
        managersIdCardNo: null,
        managersPosition: null,
        managersEmail: null,
        managersDocumentsValidity: null,
        managersLanline: null,
        managersMobile: null,
        managersZip: null,
        managersAddress: '',
        relationshipWithOrg: '',
        isManagerValidateForever: false,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'managersName',
          label: '姓名',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersDocumentsType',
          label: '证件类型',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersIdCardNo',
          label: '证件号码',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersDocumentsValidity',
          label: '证件有效期',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersSex',
          label: '性别',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersAge',
          label: '年龄',
          props: {
            readonly: true,
            type: 'text',
          },
        },
        {
          type: 'input',
          modelKey: 'managersPosition',
          label: '职务',
          props: {
            type: 'text',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersEmail',
          label: '电子邮箱',
          props: {
            type: 'tel',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersLanline',
          label: '座机',
          props: {
            type: 'tel',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersMobile',
          label: '手机',
          props: {
            type: 'tel',
            readonly: true,
          },
        },
        {
          type: 'input',
          modelKey: 'managersZip',
          label: '邮编',
          props: {
            type: 'number',
            readonly: true,
          },
        },
        {
          type: 'textarea',
          modelKey: 'managersAddress',
          label: '住址',
          props: {
            readonly: true,
            placeholder: '',
          },
        },
        {
          type: 'textarea',
          modelKey: 'relationshipWithOrg',
          label: '与该机构关系',
          props: {
            readonly: true,
            placeholder: '',
          },
        },
      ],
    };
  },
};
export default mixin;
